import { render, staticRenderFns } from "./NDEConfectionSplitCriteriaForm.vue?vue&type=template&id=46d989d0&"
import script from "./NDEConfectionSplitCriteriaForm.vue?vue&type=script&lang=js&"
export * from "./NDEConfectionSplitCriteriaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports